import axios from "axios";

import { apiEndpoint } from "../configuration";
import CookiesServices from "../services/CookiesServices";

axios.defaults.withCredentials = true;

const http = axios.create({
  baseURL: apiEndpoint,
  withCredentials: true,
});

export const setupInterceptors = (navigate) => {
  http.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      // For login endpoint, disable withCredentials to avoid CORS issues
      // Allow explicit override via config, but default login to false
      const isLoginEndpoint = config.url && config.url.includes('/adminusers/verify');
      if (isLoginEndpoint && config.withCredentials !== false) {
        // Force false for login endpoint to avoid CORS issues
        config.withCredentials = false;
      } else if (config.withCredentials === undefined) {
        // Default to true for other authenticated requests
        config.withCredentials = true;
      }
      
      let token = CookiesServices.get("token");
      if (process.env.NODE_ENV === 'development') {
        console.log('CookiesServices.get("token")>', token);
      }
      
      // Only add Authorization header if token exists (skip for login)
      if (token && !config.url?.includes('/adminusers/verify')) {
        config.headers.set("Authorization", `Bearer ${token}`);
      }

      if (config.url === "/api/documents/upload") {
        config.headers.set("Content-Type", "multipart/form-data");
      } else {
        config.headers.set("Content-Type", "application/json");
      }
      
      config.headers.set("Accept", "application/json");
      
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
  http.interceptors.response.use(
    (res) => {
      // success
      return res;
    },
    (err) => {
      if (process.env.NODE_ENV === 'development') {
        console.log("err", err);
      }

      const { code } = err;
      if (code === "ERR_NETWORK") {
        if (process.env.NODE_ENV === 'development') {
          console.log("network Error");
        }
        // Don't show alert for network errors in production/staging
        // The calling code will handle the error
      }
      
      // Check if err.response exists before accessing status
      if (err.response) {
        const { status } = err.response;
        if (status === 401) {
          // here we have access of the useHistory() from current Router
          // navigate("/sessiontimeout");
        }
      }

      return Promise.reject(err);
    }
  );
};

export default http;
